<template>
  <div class="login-register-form">
    <div v-if="!registerSuccess">
      <div>
        <Title>{{ getTitle() }}</Title>
        <ui-notice
          v-if="verification && verificationMessage"
          :type="getVerificationType()"
          >{{ verificationMessage }}</ui-notice
        >
        <md-field v-if="isRegister">
          <label>Nom d'utilisateur</label>
          <md-input v-model="username"></md-input>
        </md-field>
        <md-field>
          <label>{{ getEmailLabel() }}</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field>
          <label>Mot de passe</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <md-field v-if="isRegister">
          <label>Répétez le mot de passe</label>
          <md-input v-model="passwordRepeat" type="password"></md-input>
        </md-field>
        <md-snackbar
          md-position="center"
          :md-duration="Infinity"
          :md-active.sync="showSnackbar"
          md-persistent
        >
          <p v-html="errorMessage"></p>
          <md-button class="md-primary" @click="showSnackbar = false"
            >OK</md-button
          >
        </md-snackbar>
      </div>
      <p>
        {{ getSwitchText() }}<br />
        <ui-button
          :loading="loading"
          text
          color="primary"
          @click="switchForm()"
          >{{ getSwitchTextBtn() }}</ui-button
        >
      </p>
      <ui-button @click="submit()">{{ getTextBtn() }}</ui-button>
      <sep><strong>OU</strong></sep>
      <GoogleSignIn @success="closeModal()"
        >{{ getTextBtn() }} avec Google</GoogleSignIn
      >
    </div>
    <div v-else>
      <div class="login-register-form__success">
        <svgicon icon="check-circle" />
        <Title>Incription Réussie!</Title>
        <p>
          Merci pour votre inscription, veuillez cliquer sur le
          <strong>lien de validation</strong> envoyé à votre email ({{
            this.email
          }})
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import UiNotice from "@/components/ui/UiNotice.vue";
import Title from "@/components/ui/Title.vue";
import UiButton from "@/components/ui/UiButton.vue";
import Sep from "@/components/ui/Sep.vue";
import GoogleSignIn from "@/components/ui/GoogleSignIn.vue";
import fetchApi from "@/mixins/fetchApi";
import UserStore from "@/store/userStore";
import { EventBus } from "@/mixins/event-bus";

export default {
  props: {
    registerView: { default: false },
    verification: { default: false },
    verificationSuccess: { default: false }
  },
  created() {
    this.isRegister = this.registerView;
  },
  data() {
    return {
      email: "",
      password: "",
      passwordRepeat: "",
      username: "",
      isRegister: false,
      loading: false,
      showSnackbar: false,
      errorMessage: "",
      verificationMessage: this.verification,
      registerSuccess: false
    };
  },
  components: { GoogleSignIn, Sep, UiButton, Title, UiNotice },
  methods: {
    closeModal() {
      EventBus.$emit("closeLoginModal");
    },
    submit() {
      if (this.isRegister) {
        if (this.password !== this.passwordRepeat) {
          this.errorMessage = "Les mot de passe doivent être identique";
        } else {
          this.register();
        }
      } else {
        this.login();
      }
    },
    async register() {
      const response = await fetchApi.post("users/register", {
        name: this.username,
        email: this.email,
        password: this.password
      });
      if (response.status === 200) {
        this.$emit("register");
        this.registerSuccess = true;
      } else {
        this.errorMessage = response.data.message;
        this.showSnackbar = true;
      }
    },
    async login() {
      const response = await fetchApi.auth("token", {
        username: this.email,
        password: this.password
      });
      if (response.statusText == "OK" || response.status === 200) {
        UserStore.commit("signOut");
        UserStore.commit("setUserData", response.data);
        UserStore.commit("setLogged", true);
        UserStore.commit("saveLocalStorage");
        fetchApi.setAxiosHeaders();
        this.$emit("login");
      } else {
        this.errorMessage = response.data.message;
        this.showSnackbar = true;
      }
    },
    switchForm() {
      this.verificationMessage = false;
      this.isRegister = !this.isRegister;
    },
    getVerificationType() {
      return this.verificationSuccess ? "success" : "error";
    },
    getTitle() {
      if (this.isRegister) {
        return "Inscription";
      } else {
        return "Connexion";
      }
    },
    getEmailLabel() {
      if (this.isRegister) {
        return "Email";
      } else {
        return "Email ou Nom d'utilisateur";
      }
    },
    getSwitchText() {
      if (this.isRegister) {
        return "Vous avez déjà un compte ?";
      } else {
        return "Vous n'avez pas de compte ?";
      }
    },
    getSwitchTextBtn() {
      if (this.isRegister) {
        return "Connectez-vous";
      } else {
        return "Inscrivez-vous";
      }
    },
    getTextBtn() {
      if (this.isRegister) {
        return "S'inscrire";
      } else {
        return "Se connecter";
      }
    }
  }
};
</script>
<style lang="scss">
.test {
  color: $red;
}
.login-register-form__success {
  svg {
    width: 100px;
    height: 100px;
    stroke: $green;
    margin-bottom: 10px;
  }
}
</style>
